import Controller from '@ember/controller';

export default class AuthenticatedProjectsShowProjectVersionsShowFilesController extends Controller {}
